module.exports = __webpack_public_path__ + "static/media/Steering_White.d96ff695.webp";